import { Controller } from "@hotwired/stimulus";
import { resetForm } from "../utils/forms_utils";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    $(this.element).on("hide.bs.modal", () => {
      resetForm(this.formTarget);
    });
  }
}
